import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketMergeMessagesLocalStorage = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleMergeMessagesLocalStorage = (data) => {
        const isTenantIdValid = `${api.defaults.headers.tenantId}` === `${data.tenantId}`;
        const { shouldRemoveMergeMessagesLocalStorage } = data;

        if (!isTenantIdValid || !shouldRemoveMergeMessagesLocalStorage) return;

        if (data.action === "deleteTicket") {
          const mergeMessagesLocalStorage = localStorage.getItem("mergeMessagesFromDifferentConnections");
          if (!mergeMessagesLocalStorage) return;

          const mergeMessagesArray = JSON.parse(mergeMessagesLocalStorage).filter(element => element.ticketId !== data.ticketId);
          localStorage.setItem("mergeMessagesFromDifferentConnections", JSON.stringify(mergeMessagesArray));
        }
      };

      socket.on("ticket", handleMergeMessagesLocalStorage);

      return () => {
        socket.off("ticket", handleMergeMessagesLocalStorage);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketMergeMessagesLocalStorage;
